import { render, staticRenderFns } from "./FillPage.vue?vue&type=template&id=48797e19&scoped=true&"
import script from "./FillPage.vue?vue&type=script&lang=js&"
export * from "./FillPage.vue?vue&type=script&lang=js&"
import style0 from "./FillPage.vue?vue&type=style&index=0&id=48797e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48797e19",
  null
  
)

export default component.exports